import { css } from 'styled-components'

export const textSizeM = css`
  font-size: 17px;
  line-height: 22px;
  letter-spacing: 0.14px;
`

export const textSizeS = css`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.14px;
`
